import { Button } from "@mui/material"
import { GridRenderCellParams } from "@mui/x-data-grid"
import strings from 'strings'

const t = strings.ELD_VISIBILITY

const eldListColumnsDefinition = [
    {
        field: 'id',
        headerName: 'Telematics ID',
        minWidth: 50,
        flex: 0,
        sortable: false,
    },
    {
        field: 'eldProviderName',
        headerName: 'Telematics Provider Name',
        minWidth: 150,
        flex: 1.5,
        sortable: true,
    },
    {
        field: 'isActive',
        headerName: 'Status',
        minWidth: 100,
        flex: 1,
        sortable: true,
        renderCell: (params: GridRenderCellParams) => {
            return params.value ? 'Active' : 'Inactive'
        },
    },
    {
        field: 'createdTime',
        headerName: 'Created At',
        minWidth: 180,
        flex: 1,
        sortable: true,
        renderCell: (params: GridRenderCellParams) => {
            return new Date(params.value).toLocaleString()
        },
    },
    {
        field: 'updatedTime',
        headerName: 'Last Updated',
        minWidth: 180,
        flex: 1,
        sortable: true,
        renderCell: (params: GridRenderCellParams) => {
            return new Date(params.value).toLocaleString()
        },
    },
]

const availableEldColumnsDefinition = [
    {
        field: 'id',
        headerName: 'ID',
        minWidth: 50,
        flex: 0,
        sortable: false,
    },
    {
        field: 'name',
        headerName: 'Telematics Provider Name',
        minWidth: 150,
        flex: 1.5,
        sortable: true,
    },
    {
        field: 'displayName',
        headerName: 'Display Name',
        minWidth: 150,
        flex: 1,
        sortable: true,
    },
]

const actionList = [
    {
        name: 'Remove',
        icon: 'icon_delete',
        iconSize: 40,
    },
]

const eldListColumns = {
    columns: eldListColumnsDefinition.map(({ field, headerName, minWidth, flex, sortable, renderCell }) => ({
        field,
        headerName,
        minWidth,
        flex,
        sortable,
        renderCell,
    }))
}

const availableEldColumns = {
    columns: availableEldColumnsDefinition.map(({ field, headerName, minWidth, flex, sortable }) => ({
        field,
        headerName,
        minWidth,
        flex,
        sortable,
    }))
}

export { eldListColumns, availableEldColumns, actionList } 